import { Heading } from "./Heading";
import { DiscordButton } from "./DiscordButton";
import {
  componentSpace,
  componentSpaceMobile,
  lineHeight,
  middleSpace,
  middleSpaceMobile,
  smallSpace,
  styles,
} from "../../../theme/styles";
import { useMediaQuery, useTheme } from "@mui/material";

export const WelcomePlayer = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <>
      <Heading
        variant={"h2"}
        style={
          isDesktop
            ? { marginTop: componentSpace, padding: "0px", lineHeight }
            : {
                marginTop: componentSpaceMobile,
                padding: "0px",
                lineHeight,
              }
        }
      >
        Domine o jogo <br /> com um{" "}
        <label style={styles.greenLabel}>assistente de AI
        </label>
      </Heading>
      <Heading
        variant={"h5"}
        style={
          isDesktop
            ? {
                fontSize: "16px",
                marginBottom: middleSpace,
                marginTop: smallSpace,
              }
            : {
                fontSize: "16px",
                marginBottom: middleSpaceMobile,
                marginTop: smallSpace,
              }
        }
      >
        Receba treinamento personalizado, sugestões de drafts, dicas de
        <br /> matchups e muito mais, disponíveis por meio do Discord.
      </Heading>
      <DiscordButton></DiscordButton>
      <Heading
        variant={"h6"}
        style={{ fontSize: "11.60px", marginTop: smallSpace }}
      >
        <label>Se junte a comunidade de 300+ jogadores hoje</label>
      </Heading>
    </>
  );
};
